import React from "react";
import { Box, Typography, Grid, Paper, Button } from "@material-ui/core";
import {
  TrackChanges,
  People,
  Chat,
  TrendingUp,
  
  NotificationsActive,
  Map,
} from "@material-ui/icons";
import {
  EventNote,
  EmojiObjects,
  Assignment,
  VolumeUp,
  FontDownload,
  Assessment,
  MenuBook,
  CalendarToday,
  EmojiEmotions
} from '@material-ui/icons';

import { useHistory } from "react-router-dom";  // ✅ Only this for React Router v5

const tools = [
   {
    title: "Calendar of Events",
    icon: <CalendarToday style={{ fontSize: 40 }} />,
    description:
      "The Calendar of Events provides a clear view of key school activities and dates, helping teachers, students, and educators stay informed and plan throughout the year."
  },
  
  {
    title: "Activities",
    icon: <EmojiObjects style={{ fontSize: 40 }} />,
    description:
      "In Montessori education, “activities” are hands-on tasks that help children build skills. They are chosen based on the child’s age and development. The app records each activity a student does and how well they did it."
  },
  {
    title: "Assignments",
    icon: <Assignment style={{ fontSize: 40 }} />,
    description:
      "In Montessori, assignments are activities chosen for each child based on their level and interests. This app helps parents see which assignments are given and which ones their child has completed. Option for resubmission."
  },
 {
    title: "Charts – Movable Alphabets",
    icon: <FontDownload style={{ fontSize: 40 }} />,
    description:
      "The Movable Alphabet is a hands-on tool that helps children learn to write and spell before they can use a pencil. It helps teachers track which words each child has learned and plan what to teach next."
  },
  {
    title: "Lesson Plans",
    icon: <MenuBook style={{ fontSize: 40 }} />,
    description:
      "Pre-designed lesson plans include objectives, materials, procedures, and key points of interest, helping teachers prepare more effectively and deliver lessons with all necessary resources at hand."
  },
  {
    title: "Reports",
    icon: <Assessment style={{ fontSize: 40 }} />,
    description:
      "Reports are tools used by teachers to plan and track each student’s activities and progress throughout the week. It ensures that children work across all areas—at their own pace, while still meeting learning goals."
  },
   {
    title: "Charts – Sounds",
    icon: <VolumeUp style={{ fontSize: 40 }} />,
    description:
      "In Montessori education, 'sounds' mean the phonetic sounds of letters, not their names. This is important for early reading and writing. The tool helps track which sounds each student has practiced and plan the next ones to learn."
  },
   
 
 {
    title: "Activity Planner",
    icon: <EventNote style={{ fontSize: 40 }} />,
    description:
      "Activity planner is a tool used by teachers to plan and track each student’s activities and progress throughout the week. It helps ensure that children are working across all areas—like language, math, and practical life—at their own pace, while still meeting learning goals."
  },
  {
    title: "Kids Own Stories",
    icon: <EmojiEmotions style={{ fontSize: 40 }} />,
    description: (
      <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
        <li>AI-Driven Interest Mapping & Career Matching</li>
        <li>Adaptive Learning Pathways & Content Suggestions</li>
        <li>Educator Dashboards & Progress Analytics</li>
        <li>Parent Engagement Tools & Real-Time Update</li>
        <li>Cloud-Based & Scalable for Institutions</li>
      </ul>
    )
  }
];

export default function FeaturedTools() {
  const history = useHistory(); // ✅ for v5

  return (
    <Box py={6} px={2} bgcolor="#f9fbfc">
      <Typography variant="h4" align="center" gutterBottom style={{ fontWeight: 600 }}>
        Featured Tools
      </Typography>
      <Typography variant="subtitle1" align="center" color="textSecondary" gutterBottom>
        Discover our comprehensive suite of tools designed specifically for Montessori education. Each <br />
        feature is crafted to enhance learning outcomes and streamline school operations.
      </Typography>

      <Grid container spacing={3} justifyContent="center" style={{ marginTop: 20 }}>
        {tools.map((tool, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
  <Paper
    elevation={1}
    style={{
      padding: 20,
      textAlign: "center",
      borderRadius: 12,
      transition: "transform 0.3s, box-shadow 0.3s",
      cursor: "pointer",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "scale(1.05)";
      e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.15)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "scale(1)";
      e.currentTarget.style.boxShadow = "none";
    }}
  >
    <Box mb={1}>{tool.icon}</Box>
    <Typography variant="h6" style={{ fontWeight: 600 }}>
      {tool.title}
    </Typography>
    <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
      {tool.description}
    </Typography>
  </Paper>
</Grid>

        ))}
      </Grid>

      {/* Call to Action */}
      <Box mt={6} display="flex" justifyContent="center">
        <Paper
          elevation={0}
          style={{
            padding: 24,
            borderRadius: 16,
            textAlign: "center",
            background: "linear-gradient(to right, #f0f5ff, #e6f7ff)",
            width: "100%",
            maxWidth: 800,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Ready to Transform Your School?
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Join hundreds of Montessori schools that have embraced this experience and improved learning outcomes with Montessori.
          </Typography>
          <Box mt={2}>
            <Button
              variant="contained"
              color="primary"
              style={{ textTransform: "none" }}
              onClick={() => history.push("/montessori/schoolregistration")}
            >
              Start Free Trial
            </Button>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}
